module.exports = __webpack_public_path__ + "static/media/img_campus_card.0910f3a7.png";